'use strict';

angular.module('estimably')
	.controller('WaitingCtrl', ["$scope", "$location", "socketService", "gameService", function ($scope, $location, socketService, gameService) {
		$scope.game = gameService;
	}]);
